<template>
  <div class="flex">
    <div style="margin-right: 5px;">
      <Select v-model="selectValue" :transfer="transfer" @on-change="changeInputValue" :style="selectStyle">
        <Option v-for="item in dropDownTimeList" :key="item.value" :value="item.value">{{ item.title }}</Option>
      </Select>
    </div>
    <Date-picker
      type="datetimerange"
      class="wid100P"
      :options="dateOptions"
      @on-clear="resetTime"
      @on-change="getTime"
      :clearable="true"
      :transfer="transfer"
      :format="formatType"
      placement="bottom-end"
      :placeholder="$t('key1000360')"
      :value="timeList">
    </Date-picker>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

export default {
  name: "dropDownDateTime",
  props: {
    dropDownTimeList: { // 下拉选项筛选条件的基础数据
      type: Array,
      default: () => []
    },
    defaultSelectValue: { // 默认展示下拉选项值
      type: Number,
      default: 1
    },
    selectStyle: { // 下拉选项的样式
      type: Object,
      default: () => {
        return {
          width: '110px'
        };
      }
    },
    formatType: { // 时间格式
      type: String,
      default: 'yyyy-MM-dd HH:mm:ss'
    },
    transfer: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      selectValue: '',
      timeList: [],
      dateOptions: {
        shortcuts: [{
          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000134'), value: function () {
            let end = new Date();
            let start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            return [start, end];
          }
        }, {
          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000135'), value: function () {
            let end = new Date();
            let start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            return [start, end];
          }
        }, {
          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000136'), value: function () {
            let end = new Date();
            let start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            return [start, end];
          }
        }]
      },
    };
  },
  methods: {
    // 切换选项
    changeInputValue(value) {
      this.$emit('changeInput', value);
    },
    // 选取订单创建时间
    getTime(value) {
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetTime();
      } else {
        if (!value[0]) {
          v.resetTime();
        } else {
          v.$emit('selectTime', {date: value, value: this.selectValue});
        }
      }
    },
    // 重置时间
    resetTime() {
      this.$emit('resetTime', this.selectValue);
    },
  },
  watch: {
    // 监听下拉选项的默认值
    defaultSelectValue: {
      handler(value) {
        let v = this;
        v.selectValue = value;
      },
      immediate: true,
      deep: true
    },
  }
};
</script>

<style scoped>

</style>